module.exports = __webpack_public_path__ + "static/media/hashim.a60eff02.jpg";